import React from 'react';
import { ColorSchemeProvider as MantineColorSchemeProvider, ColorScheme } from '@mantine/core';
import { useColorScheme, useHotkeys, useLocalStorage } from '@mantine/hooks';

import { PROJECT_SLUG } from './constants';

export const ColorSchemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const preferredColorScheme = useColorScheme();
  const [colorScheme, setColorScheme] = useLocalStorage<ColorScheme>({
    key: `${PROJECT_SLUG}_color_scheme`,
    defaultValue: preferredColorScheme,
    getInitialValueInEffect: true,
  });

  const toggleColorScheme = (value?: ColorScheme) => setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));

  useHotkeys([['mod+J', () => toggleColorScheme()]]);

  return (
    <MantineColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
      {children}
    </MantineColorSchemeProvider>
  );
};
